module.exports = function getResource(label, vars = []) {
    let resources = {
        please: 'Veuillez',
        signIn: 'ouvrir une session',
        toViewThisPage: 'pour afficher cette page.'
    };
    return resources[label];
};
